import React from "react";
import OnBoardingLayout from "../utils/on-boarding-layout";
import { useLocation } from "react-router-dom";
import GenericMessage from "../builders/genericMessage";

export default function MessageScreen() {
  const location = useLocation();
  const type = location.state.type;

  return (
    <OnBoardingLayout
      screen={<GenericMessage type={type} />}
      cardNotification={true} rendersize={true}
    />
  );
}
